import { ReactNode } from 'react';
import Alert from 'antd/lib/alert';
import Row from 'antd/lib/row';
import Space from 'antd/lib/space';
import Typography from 'antd/lib/typography';
import FileTextOutlined from '@ant-design/icons/lib/icons/FileTextOutlined';
import { SECONDARY_COLOR } from 'src/theme';
import { getComputerFormattedTime } from 'src/domain/date/date';
import { ICustomerUtilityBillFile, billSourceLabel, formatCustomerName } from 'src/domain/customer-utility-bill-file/interface';
import { BillStatusTag } from '../../BillStatusTag';
import { BillReadOnlyField } from '../../edit-bill/BillReadOnlyField';

const { Text } = Typography;

const formatDate = (value: string | null) => (value ? getComputerFormattedTime(value) : null);

interface Props {
    file: ICustomerUtilityBillFile;
}

export const BillFileInfoSection = ({ file }: Props) => {
    const fileFields: [string, ReactNode][] = [
        ['SOURCE', file.source?.source ? billSourceLabel(file.source.source) : null],
        ['CUSTOMER', file.source?.customerName ? formatCustomerName(file.source.customerName) : null],
        ['FILE ID', file.id],
        ['STATUS', <BillStatusTag key="status" status={file.processingStatus} />],
        ['DOWNLOADED AT', formatDate(file.downloadedAt)],
        ['PARSED AT', formatDate(file.parsedAt)],
        ['CREATED AT', formatDate(file.createdAt)],
        ['UPDATED AT', formatDate(file.updatedAt)],
    ];

    return (
        <div className="customer-bill-section-source" style={{ marginBottom: 14 }}>
            <Space style={{ marginBottom: 10 }}>
                <FileTextOutlined style={{ color: SECONDARY_COLOR }} />
                <Text strong>Customer Utility Bill File Information</Text>
            </Space>
            {file.processingError && <Alert type="error" showIcon message={file.processingError} style={{ marginBottom: 10 }} />}
            <Row gutter={[20, 10]}>
                {fileFields.map(([label, value]) => (
                    <BillReadOnlyField key={label} label={label} value={value} />
                ))}
            </Row>
        </div>
    );
};
